import React from "react";
import * as UI from "./ui.jsx";
// Admin — vendor-facing access management: invite by email, remove,
// per-section on/off grid. No finer granularity.
//
// Staff standing itself is decided in the identity provider, never here: this
// screen only distributes sections to people who already hold vendor access.

const { useState: useStateA } = React;

function AdminView() {
  const { Icon, Card, Tag, ModuleGate, MockNote } = UI;
  const { SECTIONS } = window.DATA;
  const [staff, setStaff] = useStateA(() => window.DATA.STAFF.map(s => ({ ...s, access: { ...s.access } })));
  const [email, setEmail] = useStateA("");
  const [invited, setInvited] = useStateA([]);

  const toggle = (id, section) =>
    setStaff(ss => ss.map(s => s.id === id && s.role !== "Owner"
      ? { ...s, access: { ...s.access, [section]: !s.access[section] } } : s));
  const remove = (id) => setStaff(ss => ss.filter(s => s.id !== id));
  const invite = () => {
    if (!email.trim() || !email.includes("@")) return;
    setInvited(v => [...v, email.trim()]);
    setEmail("");
  };

  return (
    <ModuleGate modules="vendor.admin">
      <div className="fade-in">
        <div className="grid admin-grid" style={{ gridTemplateColumns: "1fr 320px", gap: 22, alignItems: "start" }}>
          <Card title="Who has access"
                subtitle="Toggle sections on or off for each staff member. Owners always see everything."
                right={<MockNote module="vendor.admin"/>}>
            <div style={{ overflowX: "auto" }}>
              <table className="table access-table">
                <thead>
                  <tr>
                    <th style={{ minWidth: 170 }}>Person</th>
                    {SECTIONS.map(s => <th key={s} style={{ textAlign: "center", padding: "13px 8px" }}>{s}</th>)}
                    <th/>
                  </tr>
                </thead>
                <tbody>
                  {staff.map(p => (
                    <tr key={p.id}>
                      <td>
                        <div style={{ color: "var(--fg-1)", fontSize: 14.5 }}>{p.name} {p.role === "Owner" && <Tag variant="gold">Owner</Tag>}</div>
                        <div className="muted" style={{ fontSize: 11, marginTop: 2 }}>{p.email}</div>
                      </td>
                      {SECTIONS.map(s => (
                        <td key={s} style={{ textAlign: "center", padding: "13px 8px" }}>
                          <button className={`acc ${p.access[s] ? "on" : ""}`} disabled={p.role === "Owner"}
                                  onClick={() => toggle(p.id, s)} title={`${s}: ${p.access[s] ? "on" : "off"}`}>
                            {p.access[s] ? <Icon.check style={{ width: 13, height: 13 }}/> : ""}
                          </button>
                        </td>
                      ))}
                      <td style={{ textAlign: "right" }}>
                        {p.role !== "Owner" && (
                          <button onClick={() => remove(p.id)} title="Remove access" style={{ color: "var(--fg-muted)" }}>
                            <Icon.trash style={{ width: 16, height: 16 }}/>
                          </button>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="divider"/>
            <div className="caption">
              Changes here are held in this session only — vendor access has no provider yet.
            </div>
          </Card>

          <Card title="Invite staff" subtitle="They'll get an email link to this dashboard with the sections you allow.">
            <div className="field">
              <label>Email address</label>
              <input value={email} onChange={e => setEmail(e.target.value)} placeholder="name@example.com"
                     onKeyDown={e => e.key === "Enter" && invite()}/>
            </div>
            <button className="btn primary" onClick={invite} disabled={!email.includes("@")}>
              <Icon.mail style={{ width: 15, height: 15 }}/> Send invite
            </button>
            {invited.length > 0 && (
              <>
                <div className="divider"/>
                <div className="eyebrow" style={{ marginBottom: 8 }}>Pending invites</div>
                {invited.map((e, i) => (
                  <div key={i} className="row" style={{ justifyContent: "space-between", padding: "8px 0", borderTop: i ? "1px solid var(--divider)" : "0" }}>
                    <span style={{ fontSize: 13 }}>{e}</span>
                    <Tag>Sent</Tag>
                  </div>
                ))}
              </>
            )}
          </Card>
        </div>
      </div>
    </ModuleGate>
  );
}

export { AdminView };
